NtechApp.BusinessAccountForm = function($view) {
    var me = this;

    this._isEditing = false;

    this._$view = null;
    this._$zipCodeInput = null;
    this._$zipCodeSublabel = null;
    this._$zipCodeHidden = null;
    this._citySelect = null;

    this._click = null;
    this._ajax = null;

    this._workingHoursForm = null;
    this._workingHoursItemsCollection = null;
    this._zipCodeAuto = null;

    this._mapConfirmForm = null;
    this._$confirmMapForm = null;
    this._confirmMap = null;
    this._mapMarker = null;
    this._formSaver = null;
    this._saver = null;

    this._afterMapConfirmFormLoadTimeout = null;

    this._construct = function () {
        me._$view = $view;
        me._citySelect = NtechApp.formManager.getFormSelectById("city");

        me._$zipCodeInput = me._$view.find("[data-autocompleteid='zipCode']");
        me._$zipCodeSublabel = me._$view.find("[data-autocompleteSublabelId='zipCode']");
        me._$zipCodeHidden = me._$view.find("[data-autocompleteHiddenId='zipCode']");

        me._click = new NtechApp.TouchClickEvent();
        me._ajax = new NtechApp.Ajax();

        me._workingHoursForm = new NtechApp.WorkingHoursForm(me._$view);
        me._workingHoursItemsCollection = new NtechApp.WorkingHoursItemsCollection(
            me._$view.find("#workingHoursCustomField [data-itemsGrid]")
        );
        me._updateWorkingHoursHidden();
        
        me._zipCodeAuto = new NtechApp.Autocomplete(
            me._$zipCodeInput,
            NtechApp.merge(
                NtechApp.autocompleteSettings.default,
                {matchType: NtechApp.Autocomplete.MATCH_TYPES.START}
            ),
            function() { me._loadZipCodes.apply(me, arguments); }
        );

        me._mapConfirmForm = new NtechApp.ModalForm(NtechApp.ModalForm.CACHE);
        me._mapConfirmForm.setFormView($("#mapConfirmForm"));

        me._$confirmMapForm = $("body").find("#mapConfirmForm");
        me._createConfirmMap();
        me._bindConfirmMapEvents();

        var $formView = me._$view.find("[data-saveManagerForm]");
        me._formSaver = new NtechApp.FormSaver(
            $formView,
            $formView.attr("data-saveManagerForm"),
            $formView.attr("data-saveManagerFormRedirect"),
            function(saver) { me._findAddressCoords.call(me, saver); }
        );

        me._bindEvents();
    }

    this._bindEvents = function() {
        me._bindSharedEvents();
        me._bindZipAutoEvents();
    }

    this._bindSharedEvents = function() {
        $(window).on(NtechApp.BusinessAccountForm.EVENT_WINDOW_RESIZE, function() {
            me._updateMapHeight();
        });

        var addEv = NtechApp.WorkingHoursForm.EVENT_WORKING_HOURS_ADD;
        $(me._workingHoursForm).on(addEv, function(e, dayShiftsData) {
            if(dayShiftsData.length == 0)
                return;
            
            me._workingHoursItemsCollection.renderGrid(dayShiftsData);
            me._updateWorkingHoursHidden();
        });

        var rmEv = NtechApp.WorkingHoursItemsCollection.EVENT_ITEM_RM;
        $(me._workingHoursItemsCollection).on(rmEv, function(e) {
            me._updateWorkingHoursHidden();
        });
    }

    this._bindZipAutoEvents = function() {
        $(me._zipCodeAuto).on(NtechApp.Autocomplete.SELECT_EVENT, function(event, id, text, $searchResult) {
            me._$zipCodeSublabel.text(text);
            me._$zipCodeHidden.val(id);

            me._loadCities(id);
        });

        me._click.listen(me._zipCodeAuto.getView(), "[data-loadNextSearchResults]", function(event) {
            if($(event.target).hasClass("lockLoadNextButton"))
                return;

            var $loadNext = $(event.target).addClass("selectedItem lockLoadNextButton");
            var page = $loadNext.attr("data-loadNextSearchResults");

            me._ajax.enableTextLoading($loadNext);
            me._loadZipCodes(
                me._zipCodeAuto.getSearchVal(),
                NtechApp.bind("appendData", me._zipCodeAuto),
                NtechApp.noop,
                page
            );
        });
    }

    this._unbindEvents = function () {
    }

    this.destruct = function () {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.BusinessAccountForm.EVENT_WINDOW_RESIZE = "resize.NtechApp.BusinessAccountForm";

NtechApp.proto(NtechApp.BusinessAccountForm, {
    setIsEditing: function() {
        this._isEditing = true;
    },

    _updateWorkingHoursHidden: function() {
        var $hidden = this._$view.find("#business_account_packedWorkingHours");
        $hidden.val(this._workingHoursItemsCollection.getPackedWorkingHours());
    },

    _createConfirmMap: function() {
        this._$confirmMapForm.find(".mapWrapper").css({
            position: "relative",
            width: "100%"
        });

        this._$confirmMapForm.find(".mapMessage").css({
            position: "absolute",
            left: "0px",
            top: "0px",
            zIndex: 2,
            background: "#37bdb1",
            color: "white",
            padding: "8px 17px",
            fontSize: "12px"
        });

        this._$confirmMapForm.find("#map").css({
            width: "100%",
            zIndex: "1",
            height: "200px"
        });

        var startCoords = {lat: 25.94154, lng: -80.13861};
        this._confirmMap = new google.maps.Map(this._$confirmMapForm.find("#map").get(0), {
            center: startCoords,
            zoom: 14,
            mapTypeControl: false
        });
    },

    _bindConfirmMapEvents: function() {
        var me = this;

        this._click.listen(this._$confirmMapForm.find(".formHeader .close .button"), function() {
            me._mapConfirmForm.unload();
            clearTimeout(me._afterMapConfirmFormLoadTimeout);
        });

        this._click.listen(this._$confirmMapForm.find("[data-cancelBut]"), function() {
            me._mapConfirmForm.unload();
            clearTimeout(me._afterMapConfirmFormLoadTimeout);
        });

        this._click.listen(this._$confirmMapForm.find("[data-confirmBut]"), function() {
            me._mapConfirmForm.unload();
            me._formSaver.start();

            me._saver();
            me._saver = null;
        });
    },

    _updateMapHeight: function() {
        var topHeight = this._$confirmMapForm.find(".formHeader").outerHeight();
        var bottomHeight = this._$confirmMapForm.find(".formControls").outerHeight();
        var formHeight = this._$confirmMapForm.outerHeight();
        var newHeight = formHeight - topHeight - bottomHeight - 2;

        this._$confirmMapForm.find("#mapWrapper").height(newHeight);
        this._$confirmMapForm.find("#map").height(newHeight);
    },

    _loadZipCodes: function(searchVal, onFoundData, onNotFoundData, page) {
        var me = this;
        var params = {
            searchType: NtechApp.searchTypes.ZIP_CODES,
            searchText: searchVal,
            searchPage: page || 0
        };

        me._ajax.get({
            url: Routing.generate('search', params),
            onSuccess: function(data) {
                if(data.hasResults)
                    onFoundData(data.html);
                else
                    onNotFoundData(data.html);
            },
            onComplete: function() {
                //if(me._nextLoadRequestData == null)
                //    me._loaderOff();
            }
        });
    },

    _loadCities: function(zipCodeId) {
        var me = this;
        var params = {
            zipCodeId: zipCodeId
        };

        me._citySelect.lock();
        me._citySelect.clearVal();
        me._citySelect.enableLoader();

        me._ajax.get({
            url: Routing.generate('search_cities_by_zip', params),
            onSuccess: function(data) {
                me._updateCitySelect(data.results);
            },
            onComplete: function() {
                me._citySelect.disableLoader();
                //if(me._nextLoadRequestData == null)
                //    me._loaderOff();
            }
        });
    },

    _updateCitySelect: function(citiesData) {
        this._citySelect.unlock();

        var labels = [];
        var vals = [];
        for(var i = 0; i < citiesData.length; i++) {
            labels.push(citiesData[i].name);
            vals.push(citiesData[i].id);
        }

        this._citySelect.reinsertOptions(labels, vals);
    },

    _findAddressCoords: function(saver) {
        var me = this;

        if(me._isEditing)
            var route = "business_validate_edit_account_form";
        else 
            var route = "business_validate_account_form";

        this._ajax.post({
            url: Routing.generate(route),
            data: this._formSaver.getRequestData(),
            onSuccess: function(data) {
                if(me._isEditing) 
                    var showMap = data.wasAddressChanged;
                else
                    var showMap = true;

                if(showMap) {
                    me._mapConfirmForm.forceCacheCallback();
                    me._mapConfirmForm.load("fakecacheroute", function($form) {
                        me._afterMapConfirmFormLoadTimeout = setTimeout(function() { 
                            me._afterMapConfirmFormLoad.call(me, $form, data, saver);
                        }, 420);
                    });
                }
                else {
                    saver();
                }
            },
            onError: function(errors) {
                me._formSaver.showErrors(errors);
            },
            onComplete: function() {
                me._formSaver.stop();
            }
        });
    },

    _afterMapConfirmFormLoad: function($form, data, saver) {
        var me = this;

        $(window).trigger(NtechApp.BusinessAccountForm.EVENT_WINDOW_RESIZE);
        google.maps.event.trigger(me._confirmMap, 'resize');
        me._confirmMap.setCenter(new google.maps.LatLng(
            parseFloat(data.coords.lat),
            parseFloat(data.coords.lon)
        ));

        this._$view.find("#business_account_addressLat").val(data.coords.lat);
        this._$view.find("#business_account_addressLon").val(data.coords.lon);

        this._clearMapMarker();
        this._createMapMarker(data.coords);

        this._saver = saver;
    },

    _clearMapMarker: function() {
        if(this._mapMarker != null)
            this._mapMarker.setMap(null);

        this._mapMarker = null;
    },

    _createMapMarker: function(coords) {
        var me = this;

        var coords = {
            lat: parseFloat(coords.lat),
            lng: parseFloat(coords.lon)
        };

        this._mapMarker = new google.maps.Marker({
            position: coords,
            map: this._confirmMap,
            title: this._$view.find("#business_account_name").val()
        });
    },
});